import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    text: String
  }

  connect() {
    // Create tooltip element
    this.tooltip = document.createElement('div')
    this.tooltip.className = 'tooltip-popup'
    this.tooltip.textContent = this.textValue
    this.tooltip.style.cssText = `
      position: absolute;
      background-color: rgba(0, 0, 0, 0.9);
      color: white;
      padding: 8px 12px;
      border-radius: 4px;
      font-size: 12px;
      line-height: 1.4;
      max-width: 300px;
      z-index: 1000;
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.2s;
      white-space: normal;
    `
    document.body.appendChild(this.tooltip)
  }

  disconnect() {
    if (this.tooltip) {
      this.tooltip.remove()
    }
  }

  show(event) {
    const rect = this.element.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft

    // Position tooltip above the element, accounting for scroll position
    this.tooltip.style.left = `${rect.left + scrollLeft + rect.width / 2}px`
    this.tooltip.style.top = `${rect.top + scrollTop - 10}px`
    this.tooltip.style.transform = 'translate(-50%, -100%)'
    this.tooltip.style.opacity = '1'
  }

  hide(event) {
    this.tooltip.style.opacity = '0'
  }
}
